export const sleep1s = () => new Promise((resolve) => setTimeout(resolve, 1000));
